<section class="main-container px-1 px-sm-4">
    <main class="row">
        <div class="col-md-12 subcontainer">
            <div class="row">
                <div class="col-md-8 title-component">
                    <i class="fas fa-exclamation-triangle"></i>
                    Zonas críticas
                </div>
                <div class="col-md-4 text-right" permission-display [module]="permission.routes.module"
                    [functionality]="permission.routes.createCriticZones">
                    <button (click)="create()" type="button" mat-raised-button color="accent"
                        matTooltip="Agregar una nueva zona crítica">
                        <i class="fas fa-plus"></i>
                        Crear zona
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="table-container">
                        <table class="w-100">
                            <thead>
                                <th>Nombre</th>
                                <th class="d-none d-md-table-cell">Origen</th>
                                <th class="d-none d-md-table-cell">Destino</th>
                                <th>Acciones</th>
                            </thead>
                            <tbody>
                                <tr *ngFor="let zone of zones">
                                    <td>{{zone?.name}}</td>
                                    <td class="d-none d-md-table-cell">{{getPointLabel(zone?.start)}}</td>
                                    <td class="d-none d-md-table-cell">{{getPointLabel(zone?.end)}}</td>
                                    <td>
                                        <button type="button" class="table-menu-btn" [matMenuTriggerFor]="zoneMenu"
                                            matTooltip="Acciones">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </button>
                                        <mat-menu #zoneMenu="matMenu">
                                            <button mat-menu-item (click)="view(zone)">
                                                <i class="fas fa-eye mr-2"></i>
                                                <span>Visualizar</span>
                                            </button>
                                            <button mat-menu-item (click)="edit(zone)" *ngIf="hasPermissionEdit">
                                                <i class="fas fa-edit mr-2"></i>
                                                <span>Editar</span>
                                            </button>
                                        </mat-menu>
                                    </td>
                                </tr>
                                <tr *ngIf="zones.length === 0">
                                    <td colspan="8" class="text-center">
                                        <hr>
                                        <br>
                                        <br>
                                        <img src="../../../../assets/svg/icons/tl_ico__caja_vacia.svg">
                                        <br>
                                        <p style="font-weight: bold;">No hay resultados para ésta búsqueda</p>
                                        <br>
                                        <br>
                                        <br>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </main>
</section>